import { Flex, Tooltip, useComputedColorScheme, useMantineColorScheme } from '@mantine/core';

import Moon from '@/assets/icons/content/moon.svg';

import classes from './Navbar.module.css';

const SunPlaceholder = () => (
  <svg aria-hidden viewBox="0 0 20 20" width="20" height="20" fill="none">
    <circle cx="10" cy="10" r="3.5" fill="currentColor" />
    <path
      d="M10 1.5v2.5M10 16v2.5M18.5 10H16M4 10H1.5M16.01 3.99l-1.77 1.77M5.76 14.24l-1.77 1.77M16.01 16.01l-1.77-1.77M5.76 5.76 3.99 3.99"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

/** Bottom-of-sidebar theme control (Figma: sun/moon row). TODO: replace the inline sun placeholder with the final shared asset when it is available. */
const SidebarThemeToggle = ({ desktopOpened }: { desktopOpened: boolean }) => {
  const { setColorScheme } = useMantineColorScheme();
  const computed = useComputedColorScheme('light', { getInitialValueInEffect: true });
  const nextScheme = computed === 'light' ? 'dark' : 'light';
  const actionLabel = nextScheme === 'dark' ? 'Dark mode' : 'Light mode';

  return (
    <Flex
      align="center"
      wrap="nowrap"
      component="button"
      type="button"
      aria-label={`Switch to ${nextScheme} mode`}
      className={`${classes.footerNavRow} ${classes.footerNavButtonReset}`}
      onClick={() => setColorScheme(nextScheme)}
    >
      <Tooltip
        arrowOffset={10}
        arrowSize={4}
        label={actionLabel}
        position="right"
        offset={40}
        color="var(--active-color)"
        disabled={desktopOpened}
        visibleFrom="sm"
        transitionProps={{ duration: 0 }}
        withArrow
      >
        <span className={classes.footerNavIcon}>
          {computed === 'dark' ? <Moon width={20} height={20} /> : <SunPlaceholder />}
        </span>
      </Tooltip>

      <span className={classes.toggleLabel}>{actionLabel}</span>
    </Flex>
  );
};

export default SidebarThemeToggle;
